export default {
    set: (key, value, options = {}, raw = false, json = false) => {
        if (typeof options.expires === 'number') {
            const days = options.expires;
            const date = new Date();
            date.setDate(date.getDate() + days);
            options.expires = date.toUTCString();
        }

        value = json ? JSON.stringify(value) : String(value);
        value = raw ? value : encodeURIComponent(value);
        const keyValue = `${encodeURIComponent(key)}=${value};`;

        const optionsString = Object.keys(options)
            .map(option => {
                if (option === 'Secure') {
                    return option;
                }
                return `${option}=${options[option]}`;
            })
            .join(';');

        return document.cookie = `${keyValue} ${optionsString}`;
    },
    get: (key, raw = false, json = false) => {
        const decode = (str) => raw ? str : decodeURIComponent(str.replace(/\+/g, ' '));
        const matchingCookie = document.cookie
            .split('; ')
            .filter(cookie => cookie.split('=')[0] === key)[0];

        if (matchingCookie) {
            const decodedCookie = decode(matchingCookie).split('=')[1];
            return json ? JSON.parse(decodedCookie) : decodedCookie;
        }
        return false;
    },
    remove: function (key, options) {
        if (this.get(key)) {
            options = Object.assign({}, options, {expires: -1});
            this.set(key, null, options);
            return true;
        }
        return false;
    }
};
